module.exports = __webpack_public_path__ + "static/media/hardware4.7969e722.png";